import { Component, Input, OnInit, Output, EventEmitter} from "@angular/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Message, SpinnerService} from 'shared-components';
import { CultivosService } from '../../../../services/cultivos.service';

@Component({
    selector: 'app-cultivo-marca',
    templateUrl: './cultivo-marca.component.html'
})
export class CultivoMarcaComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

    public listaCultivosMarca;
    public listaMarcas;

    public editables;
    public new = false;
    public newEditModal = false;
    public deleteModal = false;
    public toCloseSpinner = 0;

    private _filters;
    public _cultivoMarca;
    public desFinca;
    public _cultivoId;

    public mensajes = new Array<Message>();
    public showError: boolean;
    public showWarning: boolean;

    public orderBy: string;
    public firtstime = true;
    public idColumn;

    @Input() paisId;
    @Input() denominacionId;
    @Input() aforoDisponible;
    @Input() campanyaHabilitada: boolean;
    @Input() set marcasCultivo(cultivoId: any) {
        this._cultivoId = cultivoId;
        this._filters = {
            cultivoId: this._cultivoId,
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getCultivosMarcaByCultivoId(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.listaCultivosMarca = resp.lista;
        });
    }

    @Output() pushMessage = new EventEmitter<string>();

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _cultivosService: CultivosService,
        private readonly _sessionContext: SessionContextService
    ) {}

    ngOnInit() {

    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
    }

    public refresh(value) {
        this.editables = '';
        this.newEditModal = false;
        if (value) {
            this.reload();
        }
    }

    public reload() {
        this._filters = {
            cultivoId: this._cultivoId
        };
        this.new = false;
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._cultivosService.getCultivosMarcaByCultivoId(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.listaCultivosMarca = resp.lista;
        });
    }

    public editableChanged(cultivoMarca) {
        this.editables = cultivoMarca;
        this.new = false;
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }

    public toOrderBy(id: any) {
      this.idColumn = id;
      if (this.firtstime) {
          this.orderBy = 'desc';
          this.firtstime = false;
      } else {
          if (this.orderBy === 'desc') {
              this.orderBy = 'asc';
          } else if (this.orderBy === 'asc') {
              this.orderBy = 'desc';
          }
      }
    }

    public getIcon(id: any) {
      let iconClass = 'fa fa-sort';
      if (id === this.idColumn) {
          iconClass = this.orderBy === 'desc' ? 'fa fa-sort-down' : 'fa fa-sort-up';
      }
      return iconClass;
    }
}
